module.exports = __webpack_public_path__ + "img/viacor-greenlabel_80.920638b6.png";